import React, { useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";

import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import Filter from "./non_confirming_repo_filter/Filter";
import Table from "./non_confirming_repo_table/Table";

const Non_Confirming_Repo = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Non Confirming Work Report" />
      </div>

      <div className="Sample_Report_Filter_div">
        <Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Table />
      </div>

      <Common_Report_Offcanvas
        title={"Non Confirming Work Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Non_Confirming_Repo;
